import React from "react";
import FinanceEmptyState from "./FinanceEmptyState";
import MoreOptionsDropdown from "component/flex/shipments/modals/MoreOptionsDropdown";
import { DrawerTrigger } from "component/ui/Drawer";
import { Button } from "component/ui/Button";
import { formatDate } from "component/flex/utils";
import FinanceBadge from "component/finance/FinanceBadge";
import FinanceGroupCard from "component/finance/FinanceGroupCard";
import Divider from "dashboard/component/listDivider";
import Loader from "component/loader";
import {
    displayCurrencyAndAmount,
    financeTitles,
    Loans,
    Payments,
} from "constants/FinanceConstants";
import { financeDropdownOptions, reversePaymentType } from "constants/global";

const FInanceLoanAndPayment = ({
    activeTab,
    setActiveTab,
    setActiveSubTab,
    subListFilter,
    activeSubTab,
    isLoadingAllFinancePayData,
    isLoadingFinanceGroup,
    isCancelingFinanceLoading,
    IsEmptyFinanceGroupList,
    financeGroupList,
    currency,
    navigate,
    handleCancelFinance,
    handleMakePayModal,
    handleMakeRepaymentModal,
    allFinancePayList,
    setFinanceDetails,
    deleteFinance,
    openDrawer,
}) => {
    return (
        <div className="w-full fifth-step sixth-step md:w-1/2">
            <div className="flex w-full gap-2 pl-4 overflow-x-auto rounded-lg md:overflow-hidden md:w-7/12 sm:mb-0">
                {[Loans, Payments].map((tab) => (
                    <button
                        key={tab}
                        className={`relative px-2 md:px-3 outline-0 ring-0 py-2 text-sm  transition-all duration-300 ${
                            activeTab === tab
                                ? "after:content-[''] font-[450] text-gray-90 after:absolute after:left-0 after:bottom-0 after:h-[2px] after:w-full after:bg-[#6F00FF] after:rounded-lg"
                                : "text-gray-70 font-[400]"
                        }`}
                        onClick={() => {
                            setActiveTab(tab);
                            setActiveSubTab(null);
                        }}
                    >
                        {tab}
                    </button>
                ))}
            </div>
            <div className="w-full p-2 px-3 bg-white rounded-md">
                <div className="flex w-full gap-2 py-3 mb-2 overflow-x-auto rounded-lg md:overflow-hidden sm:mb-0">
                    {subListFilter.map(({ text, value: subTab }) => (
                        <button
                            key={subTab}
                            className={`rounded py-1 sm:py-2 px-3 text-sm font-medium transition-all whitespace-nowrap duration-300 ${
                                subTab === activeSubTab
                                    ? "text-[#6F00FF] bg-[#EBE4FF]"
                                    : "text-main-grey"
                            }`}
                            onClick={() => setActiveSubTab(subTab)}
                        >
                            {text}
                        </button>
                    ))}
                </div>
                {isLoadingAllFinancePayData ||
                isLoadingFinanceGroup ||
                isCancelingFinanceLoading ? (
                    <div className="min-h-[180px] pb-6 flex flex-col items-center justify-center w-full">
                        <button className=" bg-[#6F00FF] px-4 py-2 rounded-lg">
                            <Loader />
                        </button>
                    </div>
                ) : (
                    <>
                        {/* Loan Section */}
                        {activeTab === Loans && (
                            <>
                                {IsEmptyFinanceGroupList && (
                                    <FinanceEmptyState type={activeSubTab} />
                                )}
                                {/* Inventory Finance */}
                                {financeGroupList?.inventory_finance?.length ? (
                                    <>
                                        <Divider date={financeTitles.inventory_finance} />
                                        {financeGroupList?.inventory_finance?.map(
                                            (finance, index) => {
                                                return (
                                                    <FinanceGroupCard
                                                        deleteFinance={deleteFinance}
                                                        key={index}
                                                        finance={finance}
                                                        currency={finance?.currency}
                                                        navigate={navigate}
                                                        handleCancelFinance={handleCancelFinance}
                                                        handleMakePayModal={handleMakePayModal}
                                                        handleMakeRepaymentModal={
                                                            handleMakeRepaymentModal
                                                        }
                                                    />
                                                );
                                            }
                                        )}
                                    </>
                                ) : null}
                                {/* Payable Finance */}
                                {financeGroupList?.payable_finance?.length ? (
                                    <>
                                        <Divider date={financeTitles.payable_finance} />
                                        {financeGroupList?.payable_finance?.map(
                                            (finance, index) => {
                                                return (
                                                    <FinanceGroupCard
                                                        deleteFinance={deleteFinance}
                                                        key={index}
                                                        finance={finance}
                                                        currency={currency}
                                                        navigate={navigate}
                                                        handleCancelFinance={handleCancelFinance}
                                                        handleMakePayModal={handleMakePayModal}
                                                        handleMakeRepaymentModal={
                                                            handleMakeRepaymentModal
                                                        }
                                                    />
                                                );
                                            }
                                        )}
                                    </>
                                ) : null}
                                {/* Receivable Finance */}
                                {financeGroupList?.receivable_finance?.length ? (
                                    <>
                                        <Divider date={financeTitles.receivable_finance} />
                                        {financeGroupList?.receivable_finance?.map(
                                            (finance, index) => {
                                                return (
                                                    <FinanceGroupCard
                                                        deleteFinance={deleteFinance}
                                                        key={index}
                                                        finance={finance}
                                                        currency={currency}
                                                        navigate={navigate}
                                                        handleCancelFinance={handleCancelFinance}
                                                        handleMakePayModal={handleMakePayModal}
                                                        handleMakeRepaymentModal={
                                                            handleMakeRepaymentModal
                                                        }
                                                    />
                                                );
                                            }
                                        )}
                                    </>
                                ) : null}
                    {/* Payment Finance */}
                    {financeGroupList?.payment_finance?.length ? (
                      <>
                        <Divider date={financeTitles.payment_finance} />
                        {financeGroupList?.payment_finance?.map(
                          (finance, index) => {
                            return (
                              <FinanceGroupCard
                                deleteFinance={deleteFinance}
                                key={index}
                                finance={finance}
                                currency={currency}
                                navigate={navigate}
                                handleCancelFinance={handleCancelFinance}
                                handleMakePayModal={handleMakePayModal}
                                handleMakeRepaymentModal={
                                  handleMakeRepaymentModal
                                }
                              />
                            );
                          }
                        )}
                      </>
                    ) : null}
                            </>
                        )}
                        {/* Payment section */}
                        {activeTab === Payments && (
                            <>
                                {allFinancePayList?.length ? (
                                    <>
                                        {allFinancePayList?.map((finance, index) => {
                                            const { currency, totalAmount, createdAt } =
                                                finance ?? {};
                                            return (
                                                <div
                                                    key={index}
                                                    className="flex items-center justify-between gap-4 py-2 my-2"
                                                >
                                                    <div>
                                                        <p className="font-[450] mb-1 text-gray-90 text-sm">
                                                            {displayCurrencyAndAmount(
                                                                currency,
                                                                totalAmount
                                                            )}{" "}
                                                            <FinanceBadge
                                                                badgeType={"Draft"}
                                                                text={
                                                                    reversePaymentType[
                                                                        finance?.paymentType
                                                                    ]
                                                                }
                                                            />
                                                        </p>
                                                        <p className="text-sm font-light text-gray-70">
                                                            Payment due on {formatDate(createdAt)}
                                                        </p>
                                                    </div>
                                                    <div>
                                                        <Button
                                                            size="sm"
                                                            variant="outline"
                                                            className="text-sm text-gray-90"
                                                            onClick={() =>{
                                                                setFinanceDetails({
                                                                    ...finance,
                                                                    type: Object.keys(
                                                                        financeTitles
                                                                    )[1],
                                                                })
                                                                openDrawer?.()}
                                                            }
                                                        >
                                                            <DrawerTrigger>View</DrawerTrigger>
                                                        </Button>

                                                        <MoreOptionsDropdown
                                                            options={financeDropdownOptions({
                                                                finance,
                                                                handleCancelFinance: (id) =>
                                                                    handleCancelFinance(
                                                                        id,
                                                                        "payment"
                                                                    ),
                                                                handleMakePayModal,
                                                                handleMakeRepaymentModal,
                                                                goTo: (path) =>
                                                                    navigate(path, {
                                                                        state: finance,
                                                                    }),
                                                            })}
                                                        />
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </>
                                ) : (
                                    <FinanceEmptyState text="You don’t have any processing payment yet" />
                                )}
                            </>
                        )}
                    </>
                )}
            </div>
        </div>
    );
};

export default FInanceLoanAndPayment;
